// extracted by mini-css-extract-plugin
export default {"containerChapters":"Chapters_containerChapters__W0d0C","chapters":"Chapters_chapters__uL7q8"};